import { ComponentFactoryResolver, ApplicationRef, Injector, Type, EmbeddedViewRef, ComponentRef, Injectable } from '@angular/core';
import { DynamicDialogRef, DynamicDialogComponent, DynamicDialogConfig, DynamicDialogInjector } from 'primeng/dynamicdialog';
import { delay } from 'rxjs';

export class WorkBuddyDialogConfig<T = any> extends DynamicDialogConfig<T> {
    componentType: Type<any>;
    inputs?: Record<string, any>;
    parent?: any;
}

@Injectable()
export class WorkBuddyDialogService {

    dialogComponentRefMap: Map<DynamicDialogRef, ComponentRef<DynamicDialogComponent>> = new Map();

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector
    ) { }

    public open<T = any>(componentType: Type<any>, config: DynamicDialogConfig<T>) {

        config = {
            ...config,
            showHeader: false,
            style: {
                display: 'contents'
            },
            contentStyle: {
                display: 'contents'
            },
            maskStyleClass: 'w-dialog-mask',
            componentType
        } as WorkBuddyDialogConfig;

        const dialogRef = this.appendDialogComponentToBody(config as WorkBuddyDialogConfig);

        this.dialogComponentRefMap.get(dialogRef).instance.childComponentType = componentType;

        return dialogRef;
    }

    private appendDialogComponentToBody(config: WorkBuddyDialogConfig) {
        const map = new WeakMap();
        map.set(DynamicDialogConfig, config);

        const dialogRef = new DynamicDialogRef();
        map.set(DynamicDialogRef, dialogRef);

        const sub = dialogRef.onClose.subscribe(() => {
            this.dialogComponentRefMap.get(dialogRef).instance.close();
        });

        const destroySub = dialogRef
            .onDestroy
            .pipe(
                delay(100)
            )
            .subscribe(() => {
                this.removeDialogComponentFromBody(dialogRef);
                destroySub.unsubscribe();
                sub.unsubscribe();
            });

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DynamicDialogComponent);
        const componentRef = componentFactory.create(new DynamicDialogInjector(this.injector, map));

        for (const key in config?.inputs) {
            try {
                console.log(componentRef.instance);
            } catch (error) {

            }
        }


        this.appRef.attachView(componentRef.hostView);

        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        const shell = config.parent
            ? document.getElementById(config.parent)
            : document.body; //document.getElementById('shell');
        shell.appendChild(domElem);

        this.dialogComponentRefMap.set(dialogRef, componentRef);

        // hack to get aria-labelledby to work
        const ref = this.dialogComponentRefMap.get(dialogRef);
        const dynamicComponent = ref?.instance as DynamicDialogComponent;

        const ariaLabelledBy = dynamicComponent.getAriaLabelledBy();
        dynamicComponent.getAriaLabelledBy = () => ariaLabelledBy;
        //end hack

        return dialogRef;
    }

    private removeDialogComponentFromBody(dialogRef: DynamicDialogRef) {
        if (!dialogRef || !this.dialogComponentRefMap.has(dialogRef)) {
            return;
        }

        const dialogComponentRef = this.dialogComponentRefMap.get(dialogRef);
        this.appRef.detachView(dialogComponentRef.hostView);
        dialogComponentRef.destroy();
        this.dialogComponentRefMap.delete(dialogRef);
    }
}